import { useEffect } from "react";

export default function useIntersectionObserver({ targetRef }) {
  useEffect(() => {
    if (!targetRef.current) return;
    const nav = document.querySelector(".new-header");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          nav.classList.add("bg-[#0E2F5D]");
          console.log("Target is not visible");
        } else {
          nav.classList.remove("bg-[#0E2F5D]");
          console.log("Target is visible");
        }
      },
      { threshold: 0.1, rootMargin: "50px" }
    );

    observer.observe(targetRef.current);

    return () => observer.disconnect();
  }, [targetRef]);
}
